exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#remove-img-container{position:absolute;bottom:10px}", ""]);

// exports
